import { Typography } from "antd";
import { VehicleSection } from "./sections/VehicleSection";
import { RadDevicesPanel } from "./sections/RadDevicesPanel";

const { Title } = Typography;

export const VehiclesConfig = ({ configuration, radDevices, action, setAction, setManaging, setSave }) => {
    return (
        <div className="manageBox">
            <Title level={2} className="rz-mng-section">Vehicle Management</Title>
            <VehicleSection
                configuration={configuration}
                vehicles={configuration.Vehicles}
                radDevices={radDevices || []}
                setManaging={setManaging}
                action={action}
                setAction={setAction}
                setSave={setSave}
                radDevicesPanel={<RadDevicesPanel radDevices={radDevices || []} />}
            />
        </div>
    )
}
